import styled from "styled-components"

export const TooltipContainer = styled.div`
  position: relative;
  margin-left: 14px;

  button {
    all: unset;
    cursor: pointer;
    position: absolute;
    top: -10px;
    left: -9px;
  }
`

export const Arrow = styled.div`
  position: absolute;
  left: -12px;
  transform: rotate(90deg);
  background: ${({theme}) => theme.accent};
  width: 16px;
  height: 8px;
  clip-path: polygon(50% 100%, 0 0, 100% 0);
`

export const InfoBox = styled.div`
  position: absolute;
  z-index: 10;
  top: -20px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0.1px;
  text-align: center;
  text-transform: initial;
  color: ${({theme}) => theme.white};
  padding: 11px 17px;
  background: ${({theme}) => theme.accent};
  white-space: nowrap;
  transition: all 300ms ease;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    white-space: pre-wrap;
  }

  button {
    all: unset;
    cursor: pointer;
    margin-left: 5px;
  }
`
